import PopperJS from "popper.js";
import { createContext, useContext } from "react";

interface IPopoverContextValue {
  popoverRef: React.RefObject<HTMLElement | null | undefined> | null | undefined;
  placement: PopperJS.Placement;
  referenceRef: React.RefObject<HTMLElement | null | undefined> | null | undefined;
  headerId: string;
  bodyId: string;
  popoverId: string;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
  trigger: "hover" | "click";
  isOpen?: boolean;
  onBlur: React.FocusEventHandler<HTMLElement>;
  closeOnEsc: boolean;
  initialFocusRef: React.RefObject<HTMLElement | null | undefined> | null | undefined;
  isHoveringRef: React.RefObject<boolean | null | undefined> | null | undefined;
  usePortal: boolean;
}

const PopoverContext = createContext<IPopoverContextValue>({
  popoverRef: null,
  placement: "auto",
  referenceRef: null,
  headerId: "",
  bodyId: "",
  popoverId: "",
  onOpen: () => {},
  onClose: () => {},
  onToggle: () => {},
  trigger: "click",
  isOpen: false,
  onBlur: () => {},
  closeOnEsc: false,
  initialFocusRef: null,
  isHoveringRef: null,
  usePortal: false,
});

export default PopoverContext;

export const usePopoverContext = () => {
  const context = useContext(PopoverContext);
  if (context == null) {
    throw Error("usePopoverContext must be used within <Popover/>");
  }

  return context;
};
